import React, { useEffect, useState } from 'react';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Request from '~/providers/Request';
import isBlank from '~/utils/isBlank';
import I18n from '~/i18n';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import Divider from '@material-ui/core/Divider';
import { useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';

export default function AvailableDates (props) {
  const { doctor, dates, specialty } = props;
  const [hours, setHours] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState();
  const { t } = useTranslation();

  useEffect(() => {
  }, []);

  const fetchHours = async (date) => {
    setLoading(true);
    const { data } = await Request.get(`/admin/schedules/available_hours?date=${date}&doctor_id=${doctor.id}&specialty_id=${specialty.id}`, null, { normalizeJSON: false });
    const { hours, schedules, appointments } = data;
    setLoading(false);
    setHours(hours);
    setSchedules(schedules);
    setAppointments(appointments);
    setDate(date);
  };

  const ContentDialog = () => {
    return(
      <div style={{ flex: 1, padding: 20, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>

        {/* Header */}
        <div style={{ fontWeight: 'bold', flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 30, marginBottom: 20 }}>
          {moment(date).format('LLLL').split(' ').slice(0, 6).join(' ')}
        </div>

        {/* Doctor / Specialty */}
        <div style={{ flex: 1, color: 'grey', display: 'flex', justifyContent: 'center', alignItems: 'center', fontSize: 20, marginBottom: 20 }}>
          {`${doctor.name} | ${specialty.name}`}
        </div>

        <Divider />

        {/* Content */}
        <div style={{ flex: 1, display: 'flex', marginTop: 20, flexDirection: 'row' }}>

          <div style={{ flex: 1, flexDirection: 'column', marginRight: 20 }}>

            {/* Column Schedules */}
            <div style={{ fontSize: 20 }}>
              {I18n.t('related_schedules')}
            </div>

            <div style={{ flex: 1, marginBottom: 20 }}>
              <List>
                {schedules && schedules.map((schedule) => {
                  return (
                    <a
                      rel="noopener noreferrer"
                      key={`schedule-${schedule.id}`}
                      target="_blank"
                      href={`/schedules/show/${schedule.id}`}
                      style={{ textDecoration: 'inherit', color: 'black' }}
                    >
                      <ListItem button onClick={() => {}}>
                        <ListItemText primary={`${schedule.beginTime} às ${schedule.endTime}`} />
                        <div>{schedule.weekdays.map(e => t(`doctor_schedules.attributes.is_${e}`).slice(0, 3)).join(' | ')}</div>
                        <div style={{ padding: 10 }}>
                          {schedule.is_closed ? <CloseIcon /> : <CheckIcon />}
                        </div>
                      </ListItem>
                    </a>
                  );
                })}
                {isBlank(schedules) && <ListItemText style={{ color: '#aaa' }} primary={I18n.t('no_registers')} />}
              </List>
            </div>

            {/* Column Appointments */}
            <div style={{ fontSize: 20 }}>
              {I18n.t('related_appointments')}
            </div>
            <div style={{ flex: 1 }}>
              <List>
                {appointments && appointments.map((appointment) => {
                  return (
                    <a
                      rel="noopener noreferrer"
                      key={`schedule-${appointment.id}`}
                      target="_blank"
                      href={`/medical_appointments/edit/${appointment.id}`}
                      style={{ textDecoration: 'inherit', color: 'black' }}
                    >
                      <ListItem button onClick={() => {}}>
                        <ListItemText primary={`${moment(appointment.schedule_appointment_at).format('LT')} | ${appointment.user_name}`} />
                      </ListItem>
                    </a>
                  );
                })}
                {isBlank(appointments) && <ListItemText style={{ color: '#aaa' }} primary={I18n.t('no_registers')} />}
              </List>
            </div>

          </div>

          {/* Column Hours */}
          <div style={{ flex: 1, flexDirection: 'column' }}>

            <div style={{ fontSize: 17, color: '#40D5A0' }}>
              {`* ${I18n.t('observation_past_hours')}`}
            </div>

            <div style={{ fontSize: 20 }}>
              {I18n.t('hours_available')}
            </div>
            <div style={{ flex: 1, display: 'flex', flexDirection: 'row', flexWrap: 'wrap', }}>
              {hours && hours.map((hour) => {
                return (
                  <span
                    key={`hour-${hour.value}`}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      height: 50,
                      width: 90,
                      backgroundColor: hour.enabled ? '#40D5A0' : '#aaa',
                      color: 'white',
                      borderRadius: 50,
                      margin: 5,
                      fontSize: 17,
                    }}>
                    {hour.value}
                  </span>
                );
              })}
              {isBlank(hours) && <ListItemText style={{ color: '#aaa' }} primary={I18n.t('no_registers')} />}
            </div>
          </div>

        </div>
      </div>
    );
  };

  const renderModalHours = () => {
    return (
      <Dialog
        open={date}
        onClose={()=> setDate(null)}
        maxWidth={'md'}
      >
        <ContentDialog />
      </Dialog>
    );
  };

  return (
    <>
      {date && renderModalHours()}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'row', overflow: 'scroll' }}>
        {dates && dates.map((date) => {
          return (
            <div disabled={loading} onClick={() => { fetchHours(date.value); }}
              style={{
                cursor: (loading ? 'auto' : 'pointer'),
                width: 20,
                marginRight: 5,
                backgroundColor: date.enabled ? (loading ? '#ccc' : '#40D5A0') : (loading ? '#ccc' : '#aaa'),
                borderRadius: 5,
                padding: 10
              }} key={`date-${date.value}`}></div>
          );
        })}
      </div>
    </>
  );
}
